// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legalAcknowledgmentLink{\n    text-decoration: none; \n    color: red;\n    padding: 0 0.5em;\n\n}", "",{"version":3,"sources":["webpack://src/components/pages/SignUp/SignUp.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;IACV,gBAAgB;;AAEpB","sourcesContent":[".legalAcknowledgmentLink{\n    text-decoration: none; \n    color: red;\n    padding: 0 0.5em;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
